<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="sd-accordion text-sm" :class="{ 'sd-accordion--open': isOpen }">
    <button
      type="button"
      class="sd-accordion__header drag-handle flex items-center select-none w-full m-0 justify-between h-11 px-3"
      :aria-expanded="isOpen"
      @click.stop="onToggle"
    >
      <div class="flex items-center min-w-0">
        <EmojiOrIcon
          v-if="icon || emoji"
          class="inline-block w-5"
          :icon="icon"
          :emoji="emoji"
        />
        <h5 class="sd-accordion__title mb-0 py-0 truncate">
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-1 flex-shrink-0">
        <slot name="button" />
        <span
          class="sd-accordion__chevron i-lucide-chevron-down size-4"
          aria-hidden="true"
        />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="sd-accordion__body"
      :class="compact ? 'p-0' : 'p-3'"
    >
      <slot />
    </div>
  </div>
</template>
